// extracted by mini-css-extract-plugin
export default {"wrapper":"CookieBotData_wrapper--Ljs","text":"CookieBotData_text--lQV"};